<template>
    <div class="pa-2">
        <div class="row">
            <div class="col-xs-12 col-sm-3">
                <v-select label="Seleccione mes:" v-model="input.mes" :items="meses" :item-value="'id'" outlined hide-details dense />
            </div>
            <div class="col-xs-12 col-sm-2">
                <v-select label="Gestion:" v-model="input.gestion" :items="gestiones" outlined hide-details dense />
            </div>
            <div class="col-xs-12 col-sm-4">
                <v-select label="Seleccione el nit:" v-model="input.nit" :items="nits" item-text="xtext" return-object outlined hide-details dense />
            </div>
            <div class="col-xs-12 col-sm-3">
                <v-btn tile outlined color="green" @click="buscar" >Buscar</v-btn>
            </div>
        </div>

        <div class="row"> 
            <div class="col-xs-12 col-sm-3">
                <v-btn tile outlined color="orange" @click="subir">subir .csv</v-btn>
            </div>
        </div>
        <v-divider class="mt-2" />

        <div>
            <v-tabs v-model="tab" @change="tab_cmabiado">
                <v-tab>Consolidado Siat</v-tab>
                <v-tab>Consolidado Ventas</v-tab> 
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <ConsolidadoSiat ref="refConsolidadoSiat" />
                </v-tab-item>
                <v-tab-item>
                    <ConsolidadoSiat2 ref="refConsolidadoVentas" />
                </v-tab-item>
            </v-tabs-items>
        </div> 

        <Subircsv ref="refSubircsv" v-on:cargado="buscar" />
    </div>
</template>

<script>
import {meses,getGestiones,getSucursalesBySede} from './utils.ts'
import Subircsv from './subir_csv.vue'
import ConsolidadoSiat from './consolidado_siat.vue' 
import ConsolidadoSiat2 from './consolidado_sistema.vue' 

export default {
    components:{ Subircsv,ConsolidadoSiat,ConsolidadoSiat2 },
    data: () => ({
        meses, 
        loading: false,
        gestiones: [],
        nits:[], 
        tab: null,
        input: {
            mes: null,
            gestion: null,
            nit: {},
        }
    }),
    methods:{
        async get_gestiones(){
            this.loading = true;
            this.gestiones = await getGestiones(this);
            const { xxxnits } = await getSucursalesBySede(this);
            // window.console.log('----->>', xxxnits, data);
            this.nits = xxxnits;
            this.loading = false;
        },
        buscar(){
            this.tab_cmabiado(this.tab);
            
        },
        async tab_cmabiado(e){ 
            if(!this.isvalido()){
                return
            } 

            await new Promise(resolve => setTimeout(resolve, 350));

            if(e==0 && this.$refs.refConsolidadoSiat){
                this.$refs.refConsolidadoSiat.get_datos('sin',this.input.mes,this.input.gestion,this.input.nit)
            }else if(e==1 && this.$refs.refConsolidadoVentas){
                this.$refs.refConsolidadoVentas.get_datos('sistema',this.input.mes,this.input.gestion,this.input.nit)
            }
        },
        isvalido(){
            if(!this.input.mes){
                this.$root.$notify.show(`Seleccione el mes`, {color:'red',x: 'right',});
                return false
            }
            if(!this.input.gestion){
                this.$root.$notify.show(`Seleccione la gestion`, {color:'red',x: 'right',});
                return false
            }
            if(!this.input.nit || !this.input.nit.apikey){
                this.$root.$notify.show(`Seleccione el nit`, {color:'red',x: 'right',});
                return false
            }
            return true;
        },
        subir(){
            if(!this.isvalido()){
                return
            } 
            this.$refs.refSubircsv.openmodal(this.input, this.meses,this.gestiones);
        }
    },
    mounted(){
        this.get_gestiones()
    }
}

</script>
